import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

/**
 * usePrefersReducedMotion — 跟随系统动效偏好，避免轮播自动切换干扰需要减少动态效果的用户。
 * @returns {boolean} 是否应禁用非必要自动动效
 */
const usePrefersReducedMotion = (): boolean => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(() => window.matchMedia?.(QUERY).matches || false)

  useEffect(() => {
    const mediaQuery = window.matchMedia?.(QUERY)
    if (!mediaQuery) {
      return undefined
    }
    const handleChange = (event: MediaQueryListEvent) => setPrefersReducedMotion(event.matches)

    mediaQuery.addEventListener('change', handleChange)
    return () => mediaQuery.removeEventListener('change', handleChange)
  }, [])

  return prefersReducedMotion
}

export default usePrefersReducedMotion
